<template>
  <o-dropdown
    placement="left-start"
    :trigger="['hover', 'click']"
    :clickaway="false"
    :portal="false"
    :modifiers="modifiers"
    class="w-full"
    @close="handleClose()"
  >
    <div class="py-2 px-3 w-full hover:bg-gray-200 flex items-center justify-between transition duration-200 ease-in-out cursor-pointer">
      <div
        class="flex items-center"
        :class="{
          'py-2px' : !icon
        }"
      >
        <div v-if="icon" class="text-gray-700 pr-3 leading-none ">
          <component :is="iconType" :icon="icon" :src="icon" :size="iconSize" class="max-w-4" />
        </div>
        <div class="text-left pr-2">
          <p class="text-sm leading-none">
            <slot>
              {{ name }}
            </slot>
          </p>
          <p v-if="description" class="text-sm text-gray-500 leading-none mt-1">
            {{ description }}
          </p>
        </div>
      </div>
      <o-icon icon="chevronRight" :size="12" class="text-gray-600" />
    </div>

    <template #content>
      <slot name="content" />
    </template>
  </o-dropdown>
</template>

<script>
import ODropdown from './Dropdown'
import ODropdownItem from './DropdownItem'

import { icons } from '@/components/elements/Icon'

export default {
  components: {
    ODropdown,
    ODropdownItem
  },
  inject: ['dropdown'],
  props: {
    name: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: [Array, String],
      default: null
    },
    iconSize: {
      type: Number,
      default: 14
    },
    autoHideParent: {
      type: Boolean,
      default: true
    },
    modifiers: {
      type: Array,
      default: () => [
        {
          name: 'offset',
          options: {
            offset: [0, 0]
          }
        }
      ]
    }
  },
  computed: {
    iconType () {
      const icon = icons?.[this.icon]
      return icon ? 'o-icon' : 'img'
    }
  },
  methods: {
    handleClose () {
      this.hideParent()
    },
    hideParent () {
      if (this.autoHideParent) {
        this.dropdown.close()
      }
    }
  }
}
</script>
